import { render, staticRenderFns } from "./BaseLevelFilterHeaderContainer.vue?vue&type=template&id=5ffbeed2&scoped=true"
import script from "./BaseLevelFilterHeaderContainer.vue?vue&type=script&lang=js"
export * from "./BaseLevelFilterHeaderContainer.vue?vue&type=script&lang=js"
import style0 from "./BaseLevelFilterHeaderContainer.vue?vue&type=style&index=0&id=5ffbeed2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ffbeed2",
  null
  
)

export default component.exports